"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TileContextProvider = exports.TileContextConsumer = exports.defaultTileContext = void 0;

var _react = require("react");

var defaultTileContext = {
  compact: false
};
exports.defaultTileContext = defaultTileContext;

var _createContext = (0, _react.createContext)(defaultTileContext),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.TileContextProvider = Provider;
exports.TileContextConsumer = Consumer;